
<div class="container u-mt60">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard">
              Inicio
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-12">
      <h2 class="txt txt--title">Buscar conductor</h2>
      <small>Podrás revisar la información de licencias de un conductor.</small>
    </div>
    <!-- card -->
    <div class="col-md-12 u-mb60">

    <app-person-card
    [personData]="selectedPersonData || {}"
    [boxColor] ="personBoxColor"
  ></app-person-card>
  <span class="back back--small u-mt10 global-hand" (click)='searchAnotherPerson()'>
    Buscar otra persona
  </span>
</div>

    <div class="col-md-12">
      <div class="tabs tabs--orange">
        <input *ngIf="availableViews.includes('licenses')" class="state" type="radio" value="licenses" title="tab-one" [formControl]="currentViewControl" id="tab-one" />
        <input *ngIf="availableViews.includes('infractions')" class="state" type="radio" value="infractions" title="tab-two" [formControl]="currentViewControl" id="tab-two" />
        <input *ngIf="availableViews.includes('requests')" class="state" type="radio" value="requests" title="tab-three" [formControl]="currentViewControl" id="tab-three" />

        <div class="tabs__group flex-tabs">
          <label *ngIf="availableViews.includes('licenses')" for="tab-one" id="tab-one-label" class="tab__item">Licencias registradas</label>
          <label *ngIf="availableViews.includes('infractions')" for="tab-two" id="tab-two-label" class="tab__item">Infracciones</label>
          <label *ngIf="availableViews.includes('requests')" for="tab-three" id="tab-three-label" class="tab__item">Historial de solicitudes</label>

          <div id="tab-one-panel" class="tab__panel active" style="padding-top:0 !important;">
            <app-search-driver-result-licenses
              *ngIf="selectedPersonData"
              [personData]="selectedPersonData"
            ></app-search-driver-result-licenses>
          </div>

          <div id="tab-two-panel" class="tab__panel">
            <app-search-driver-result-infractions
              *ngIf="selectedPersonData"
              [userRutDv]="selectedPersonData.mdmid"
              [selectedPersonData]="selectedPersonData"
            ></app-search-driver-result-infractions>
          </div>
          <div id="tab-three-panel" class="tab__panel">
            <app-request-status
              *ngIf="selectedPersonData"
              [detailRequestShow]="true"
              [userMdmId]="selectedPersonData.mdmid"
              [shouldShowDetailButtons]="true"
            >
            </app-request-status>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
